















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "addressInput",
})
export default class addressInput extends Vue {
  private answer1 = "";
  private answer2 = "";
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    // console.log("item---", value);
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        let answer1 = "";
        value.answer.answerList.forEach((as: any) => {
          answer1 += as.name;
        });
        this.answer1 = answer1;
        this.answer2 = value.answer2;
      }
    }
  }
}
